import INVENTORY_API_BASE_URL from "../../config/api";













































































import { useState, useEffect, useRef } from "react";
import "./Outbound.css";
import Table from "react-bootstrap/Table";
import Axios from "axios";
import swal from "sweetalert";
import alertify from "alertifyjs";
import "alertifyjs/build/css/alertify.min.css";

function Outbound() {
  const [Shelfsku, setShelfsku] = useState([]);
  const [data2, setData2] = useState([]);
  const [data, setData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [barcode, setBarcode] = useState("");
  const [enteredBarcodesList, setEnteredBarcodesList] = useState([]);
  const [scannedBarcodes, setScannedBarcodes] = useState([]);
  const barcodeInputRef = useRef(null);
  const [selectedCheckboxCount, setSelectedCheckboxCount] = useState(0);
  const [selectedDistributor, setSelectedDistributor] = useState(null);
  const [isInputDisabled, setIsInputDisabled] = useState(false);

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getshipment`).then(
      (response) => {
        setData(response.data);
      }
    );
    Axios.get(`${INVENTORY_API_BASE_URL}/getship`).then((response) => {
      const latest30Data = response.data.slice(0, 200);
      const allScannedData = latest30Data
        .map((item) =>
          item.barcodeData
            .map((barcode) => barcode.scannedData)
        )
        .flat(2); 
      setData2(allScannedData); 
    });
    Axios.get(`${INVENTORY_API_BASE_URL}/getManageshelf`).then(
      (response) => {
        const shelfData = response.data;
        const allScannedDat = shelfData
          .map(
            (item) => item.barcodeData
          )
          .flat(2); 
        setShelfsku(allScannedDat); 
      }
    );
  }, []);

  const handleCheckboxChange = (orderIndex, itemIndex) => {
    const updatedSelectedRows = [...selectedRows];
    const foundIndex = updatedSelectedRows.findIndex(
      (row) => row.orderIndex === orderIndex && row.itemIndex === itemIndex
    );

    if (foundIndex === -1) {
      updatedSelectedRows.push({ orderIndex, itemIndex });
      setSelectedCheckboxCount(selectedCheckboxCount + 1);
    } else {
      updatedSelectedRows.splice(foundIndex, 1);
      setSelectedCheckboxCount(selectedCheckboxCount);
    }

    setSelectedRows(updatedSelectedRows);

    if (selectedCheckboxCount === 1) {
      window.location.reload();
    }
  };
  const handleBarcodeScanned = (scannedBarcode) => {
    const selectedRow = selectedRows.find((row) =>
      scannedBarcode.includes(
        data[row.orderIndex].updatedQuantity[row.itemIndex].sku
      )
    );

    const isBarcodeAlreadyEntered =
      enteredBarcodesList.includes(scannedBarcode);
    if (isBarcodeAlreadyEntered) {
      alertify.error("Barcode already exists in the list");
      setBarcode("");
      return;
    }

    const isBarcodeInShelf = Shelfsku.includes(scannedBarcode);
    if (isBarcodeInShelf) {
      alertify.error("Barcode is in Shelf , No Quick Outbound");
      setBarcode("");
      return;
    }

    const isBarcodeInDatabase = data2.includes(scannedBarcode);
    if (isBarcodeInDatabase) {
      alertify.error("Barcode already present in Database");
      setBarcode("");
      return;
    }

    if (selectedRow) {
      const selectedItem =
        data[selectedRow.orderIndex].updatedQuantity[selectedRow.itemIndex];
      const skuExists = selectedRows.some((row) =>
        scannedBarcode.includes(
          data[row.orderIndex].updatedQuantity[row.itemIndex].sku
        )
      );

      if (enteredBarcodesList.length === selectedItem.approvedquantity) {
        alertify.alert("Quantity matched", "Stop scanning.").set({
          onshow: function () {
            setIsInputDisabled(true);
          },
          onclose: function () {
            setIsInputDisabled(false);
          },
        });
        setBarcode("");
        return;
      }

      if (skuExists) {
        setScannedBarcodes([
          ...scannedBarcodes,
          {
            enteredBarcode: scannedBarcode,
          },
        ]);
        setBarcode("");
        setEnteredBarcodesList([...enteredBarcodesList, scannedBarcode]);

        if (enteredBarcodesList.length === selectedItem.approvedquantity - 1) {
          alertify.alert("Quantity matched", "Stop scanning.");
          setBarcode("");
          return;
        }

        alertify.success("Barcode scanned successfully");
      } else {
        alertify.error("SKU not found in the scanned barcode");
        setBarcode("");
      }
    } else {
      alertify.error("SKU not found in the scanned barcode");
      setBarcode("");
    }
  };

  const handleManualBarcodeAddition = () => {
    if (barcode.trim() !== "") {
      const skuExists = selectedRows.some((row) =>
        barcode.includes(
          data[row.orderIndex].updatedQuantity[row.itemIndex].sku
        )
      );

      if (skuExists) {
        handleBarcodeScanned(barcode);
      } else {
        alertify.error("SKU not found in the entered barcode");
        setBarcode("");
      }
    } else {
      alertify.error("Please enter a barcode");
      setBarcode("");
    }
  };

  useEffect(() => {
    if (barcodeInputRef.current) {
      barcodeInputRef.current.focus();
    }

    const handleClickOutsideInput = (event) => {
      if (
        barcodeInputRef.current &&
        !barcodeInputRef.current.contains(event.target)
      ) {
        barcodeInputRef.current.focus();
      }
    };

    document.addEventListener("click", handleClickOutsideInput);

    return () => {
      document.removeEventListener("click", handleClickOutsideInput);
    };
  }, []);

  function handleSubmit() {
    if (enteredBarcodesList.length === 0) {
      swal("Error", "Please add a barcode first", "error");
      return;
    }

    const selectedShipmentIDsString = selectedRows
      .map((row) => data[row.orderIndex].shipmentid)
      .join(", ");

    const selectedDistributorNamesString = selectedRows
      .map((row) => data[row.orderIndex].distributorName)
      .join(", ");

    const orderNumbers = selectedRows
      .map((row) => data[row.orderIndex].orderid)
      .join(", ");
    const batchIDs = selectedRows
      .map((row) => data[row.orderIndex].updatedQuantity[row.itemIndex].batchid)
      .join(", ");
    const titles = selectedRows
      .map((row) => data[row.orderIndex].updatedQuantity[row.itemIndex].title)
      .join(", ");

    const dataToSend = {
      orderno: orderNumbers,
      barcodeData: enteredBarcodesList,
      count: enteredBarcodesList.length,
      BatchID: batchIDs,
      Title: titles,
    };

    const postResult = Axios.post(
      `${INVENTORY_API_BASE_URL}/scanInbound`,
      dataToSend
    );

    const shipmentDataToPost = {
      totalCount: enteredBarcodesList.length,
      totalBoxes: 1,
      totalWeight: null,
      barcodeData: {
        BoxNo: 1,
        scannedData: enteredBarcodesList,
        count: enteredBarcodesList.length,
        OrderNum: selectedShipmentIDsString,
        DistributorName: selectedDistributorNamesString,
      },
    };

    const postResult1 = Axios.post(
      `${INVENTORY_API_BASE_URL}/createshipment`,
      shipmentDataToPost
    );
    swal({
      title: "Outbound completed",
      text: "",
      icon: "success",
    }).then(() => {
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    });
  }

  const getUniqueFilteredDistributors = () => {
    const filteredDistributors = data
      .filter((order) => order.dispatchthrough === "Pinnacle(Quick)")
      .map((order) => order.distributorName);

    const uniqueFilteredDistributors = [...new Set(filteredDistributors)];
    return uniqueFilteredDistributors;
  };

  return (
    <main className="outboundquick-container outbound-page">
      <header className="outbound-hero">
        <div className="outbound-hero__copy">
          <p className="outbound-eyebrow">Pinnacle · Quick dispatch</p>
          <h1>Quick Outbound</h1>
          <p>Scan selected order items, verify the barcode count, and complete the outbound record.</p>
        </div>
        <div className="outbound-hero__badge">
          <span className="outbound-hero__badge-icon" aria-hidden="true">OUT</span>
          <span>
            <strong>Outbound workspace</strong>
            <small>Quick dispatch orders</small>
          </span>
        </div>
      </header>

      <section className="outbound-metrics" aria-label="Quick outbound overview">
        <article className="outbound-metric">
          <span className="outbound-metric__icon" aria-hidden="true">ORD</span>
          <span className="outbound-metric__copy">
            <span>Selected items</span>
            <strong>{selectedRows.length.toLocaleString()}</strong>
          </span>
        </article>
        <article className="outbound-metric outbound-metric--scan">
          <span className="outbound-metric__icon" aria-hidden="true">SCN</span>
          <span className="outbound-metric__copy">
            <span>Barcodes entered</span>
            <strong>{enteredBarcodesList.length.toLocaleString()}</strong>
          </span>
        </article>
        <article className="outbound-metric outbound-metric--distributors">
          <span className="outbound-metric__icon" aria-hidden="true">DST</span>
          <span className="outbound-metric__copy">
            <span>Quick distributors</span>
            <strong>{getUniqueFilteredDistributors().length.toLocaleString()}</strong>
          </span>
        </article>
      </section>

      <section className="outbound-toolbar">
        <div className="outbound-toolbar__copy">
          <p className="outbound-section-eyebrow">Work queue</p>
          <h2>Quick shipment orders</h2>
          <p>Choose a distributor to narrow the orders shown below.</p>
        </div>
        <label className="outbound-filter">
          <span>Distributor</span>
          <select
            value={selectedDistributor || ""}
            onChange={(e) => setSelectedDistributor(e.target.value || null)}
          >
            <option value="">All distributors</option>
            {getUniqueFilteredDistributors().map((distributor) => (
              <option key={distributor} value={distributor}>
                {distributor}
              </option>
            ))}
          </select>
        </label>
      </section>

      <section className="outbound-panel" aria-labelledby="quick-orders-heading">
        <div className="outbound-panel__heading">
          <div>
            <p className="outbound-section-eyebrow">Order queue</p>
            <h2 id="quick-orders-heading">Orders ready for quick outbound</h2>
            <p>Select one or more order items to begin scanning.</p>
          </div>
          <span className="outbound-count-pill">
            {selectedRows.length.toLocaleString()} selected
          </span>
        </div>

        <div className="outbound-table-wrap">
          <Table className="outbound-order-table">
            <thead>
              <tr>
                <th scope="col">Order no.</th>
                <th scope="col">Distributor</th>
                <th scope="col">Approval date</th>
                <th scope="col">Select</th>
                <th scope="col">Title</th>
                <th scope="col">Medium</th>
                <th scope="col">SKU</th>
                <th scope="col">Order quantity</th>
              </tr>
            </thead>
            <tbody>
              {data.map((order, orderIndex) =>
                order.updatedQuantity.map((item, itemIndex) => {
                  if (
                    (!selectedDistributor || order.distributorName === selectedDistributor) &&
                    order.dispatchthrough === "Pinnacle(Quick)"
                  ) {
                    const isSelected = selectedRows.some(
                      (row) => row.orderIndex === orderIndex && row.itemIndex === itemIndex
                    );

                    return (
                      <tr
                        key={order.orderid + "-" + itemIndex}
                        className={isSelected ? "outbound-row--selected" : undefined}
                      >
                        {itemIndex === 0 && (
                          <>
                            <td rowSpan={order.updatedQuantity.length} className="outbound-order-id">
                              {order.shipmentid}
                            </td>
                            <td rowSpan={order.updatedQuantity.length}>
                              {order.distributorName}
                            </td>
                            <td rowSpan={order.updatedQuantity.length}>
                              {order.ApprovalDate}
                            </td>
                          </>
                        )}
                        <td className="outbound-checkbox-cell">
                          <input
                            type="checkbox"
                            onChange={() => handleCheckboxChange(orderIndex, itemIndex)}
                            checked={isSelected}
                            aria-label={"Select " + item.sku + " from order " + order.shipmentid}
                          />
                        </td>
                        <td className="outbound-title-cell">{item.title}</td>
                        <td>{item.Medium}</td>
                        <td className="outbound-sku-cell">{item.sku}</td>
                        <td className="outbound-quantity-cell">{item.approvedquantity}</td>
                      </tr>
                    );
                  }
                  return null;
                })
              )}
              {!data.some((order) =>
                (!selectedDistributor || order.distributorName === selectedDistributor) &&
                order.dispatchthrough === "Pinnacle(Quick)" &&
                order.updatedQuantity.length > 0
              ) && (
                <tr>
                  <td colSpan={8}>
                    <div className="outbound-empty">
                      <strong>No quick outbound orders found</strong>
                      <span>Orders for this distributor will appear here when they are available.</span>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </section>

      <section className="outbound-scan-panel" aria-labelledby="barcode-scanning-heading">
        {selectedRows.length > 0 ? (
          <>
            <div className="outbound-panel__heading outbound-scan-heading">
              <div>
                <p className="outbound-section-eyebrow">Scan and verify</p>
                <h2 id="barcode-scanning-heading">Barcode workspace</h2>
                <p>Scan with your barcode reader or enter a barcode manually.</p>
              </div>
              <span className="outbound-scan-status">
                <span aria-hidden="true" />
                {isInputDisabled ? "Quantity matched" : "Ready to scan"}
              </span>
            </div>

            <div className="outbound-selected-items">
              <span className="outbound-field-label">Selected order items</span>
              <div className="outbound-selected-list">
                {selectedRows.map((row) => {
                  const order = data[row.orderIndex];
                  const item = order.updatedQuantity[row.itemIndex];
                  return (
                    <span className="outbound-selected-chip" key={row.orderIndex + "-" + row.itemIndex}>
                      <strong>{item.sku}</strong>
                      <span>{order.shipmentid} · Qty {item.approvedquantity}</span>
                    </span>
                  );
                })}
              </div>
            </div>

            <div className="outbound-scan-controls">
              <label className="outbound-barcode-field">
                <span className="outbound-field-label">Enter barcode manually</span>
                <input
                  type="text"
                  ref={barcodeInputRef}
                  value={barcode}
                  onChange={(e) => setBarcode(e.target.value)}
                  onKeyUp={(e) => {
                    if (e.key === "Enter") {
                      handleManualBarcodeAddition();
                    }
                  }}
                  disabled={isInputDisabled}
                  placeholder="Scan or type a barcode"
                  autoComplete="off"
                />
              </label>
              <button
                className="outbound-add-button"
                onClick={handleManualBarcodeAddition}
                type="button"
              >
                Add barcode
                <span aria-hidden="true">+</span>
              </button>
            </div>

            <div className="outbound-barcode-summary">
              <div className="outbound-barcode-summary__heading">
                <div>
                  <span className="outbound-field-label">Scanned barcodes</span>
                  <p>Barcodes accepted for this outbound session.</p>
                </div>
                <strong className="outbound-barcode-count">{enteredBarcodesList.length}</strong>
              </div>
              {enteredBarcodesList.length > 0 ? (
                <ul className="outbound-barcode-list">
                  {enteredBarcodesList.map((barcode, index) => (
                    <li key={index}>{barcode}</li>
                  ))}
                </ul>
              ) : (
                <div className="outbound-barcode-empty">
                  Scanned barcodes will appear here.
                </div>
              )}
            </div>
          </>
        ) : (
          <div className="outbound-scan-empty">
            <span className="outbound-scan-empty__icon" aria-hidden="true">SCAN</span>
            <div>
              <p className="outbound-section-eyebrow">Scan and verify</p>
              <h2 id="barcode-scanning-heading">Barcode workspace</h2>
              <p>Select an order item above to open the scanning workspace.</p>
            </div>
          </div>
        )}
      </section>

      <footer className="outbound-footer">
        <p>
          {selectedRows.length > 0
            ? enteredBarcodesList.length + " barcode(s) ready to save."
            : "Select an order item to prepare an outbound scan."}
        </p>
        <button
          className="outbound-save-button"
          type="button"
          onClick={handleSubmit}
        >
          Save scanned ID
          <span aria-hidden="true">→</span>
        </button>
      </footer>
    </main>
  );
}

export default Outbound;
